<template>
  <div class="facebookLoginButton" id="facebookLoginButtonId" :style="[styleDebugBorder]" ref="refFacebookLoginButton">


      <div v-if="!facebookLoginScriptError" id="fb-root"></div>
    
      <div class="d-flex just-center">


    <div class="facebookButtonOuterWrapper" >
      
      <div ref="facebookButtonWrapper" id="facebookSpinnerWrapperId" class="facebookSpinnerWrapper loading" :style="{width:buttonWidth+'px'}"  :key="'facebookSpinnerKey'">
        
            <div v-if="facebookLoginScriptError" class="facebookErrorContainer" :style="{width:buttonWidth+'px'}">
                <div class="facebookLogo"> 
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"/></svg>
                </div>
                <div class="errorTextWrapper">
                  <p class="errorText" v-html="translatedWebMessages['wsm_facebook_script_error']=='wsm_facebook_script_error'?fbScriptErrorText:translatedWebMessages['wsm_facebook_script_error']">It appears that the browser is preventing Facebook from loading 
                  </p>
                  <p class="errorText bold buttonTextOnly" @click="showFacebookScriptError=!showFacebookScriptError" v-html="translatedWebMessages['wsm_facebook_script_error_solutions']=='wsm_facebook_script_error_solutions'?'( '+fbScriptErrorSolutions+' )':'( '+translatedWebMessages['wsm_facebook_script_error_solutions']+' )'">( Solutions )</p>
                  
                </div>
            </div>

            <div v-show="!isFacebookButtonLoading"> 
            <div :class="responsiveClass=='flb-w400'?'activeFlb':''" v-if="responsiveClass=='flb-w400'" :key="'facebookLoginButton400'"  class="fb-login-button flb-w400" 
            :data-width="400"
            :data-size="'large'" 
            data-button-type="login_with" 
            data-layout="default" 
            data-auto-logout-link="false" 
            data-use-continue-as="false"
            data-scope="public_profile, email"
            ></div> 


            <div :class="responsiveClass=='flb-w300'?'activeFlb':''" v-if="responsiveClass=='flb-w300'" :key="'facebookLoginButton300'"  class="fb-login-button flb-w300" 
            :data-width="300"
            :data-size="'large'" 
            data-button-type="login_with" 
            data-layout="default" 
            data-auto-logout-link="false" 
            data-use-continue-as="false"
            data-scope="public_profile, email"
            ></div> 


            <div :class="responsiveClass=='flb-w200'?'activeFlb':''" v-if="responsiveClass=='flb-w200'" :key="'facebookLoginButton200'"  class="fb-login-button flb-w200" 
            :data-width="200"
            :data-size="'medium'" 
            data-button-type="login_with" 
            data-layout="default" 
            data-auto-logout-link="false" 
            data-use-continue-as="false"
            data-scope="public_profile, email"
            ></div> 
          </div>


        <loadingBalls key="loadingBalls" v-if="isFacebookButtonLoading && !facebookLoginScriptError" :ballColor="['#e7f1fd','#b9d6fb','#8bbbf8','#5d9ff5']"></loadingBalls>
        

      </div>
      <Transition name="slideDown">

      <div v-show="(!isFacebookButtonLoading && isUserConnectedToFacebook)|| showFacebookScriptError" class="facebookButtonUserInfo" :style="{width:buttonWidth+'px'}">

        <div v-if="facebookLoginScriptError" class="facebookLoginScriptError" v-html="translatedWebMessages['wsm_facebook_script_error_helpText']=='wsm_facebook_script_error_helpText'?fbScriptErrorHelpText:translatedWebMessages['wsm_facebook_script_error_helpText']">
          <p class="title">Possible solution(s):</p>
          <p>If you're using "Private browsing" try to disable it.</p>
        </div>
        
        <div v-if="isUserConnectedToFacebook" class="d-flex flex-wrap"> 
        <p class="facebookButtonUserInfoText fbText fbCol bold">
          <span class="fbText fbCol bold" v-html="translatedWebMessages['wsm_facebook_welcome_user']=='wsm_facebook_welcome_user'?'Welcome':translatedWebMessages['wsm_facebook_welcome_user']"></span>, {{fbAPI['short_name']}} </p>
          <p @click="showFacebookLogoutContainer =!showFacebookLogoutContainer" class="facebookChangeUserText">(<span class="fbText" v-html="translatedWebMessages['wsm_facebook_are_you_not_user']=='wsm_facebook_are_you_not_user'?'Are you not':translatedWebMessages['wsm_facebook_are_you_not_user']"></span> {{fbAPI['short_name']}}?)</p>
        </div>

        <div class="facebookLogoutContainer" v-if="showFacebookLogoutContainer">
          <div class="facebookHorizontalLine"></div>

            <!-- <button @click="logoutAndOpenLoginPromptFacebook" class="facebookLogoutButton"> -->
            <button @click="logoutFacebook" class="facebookLogoutButton">
              <p v-html="translatedWebMessages['wsm_facebook_logout']=='wsm_facebook_logout'?'Logout':translatedWebMessages['wsm_facebook_logout']"></p>
            </button>  
            
          </div>
          
          <div v-if="showFacebookLogoutContainer && isUserConnectedToFacebook" class="facebookLogoutHelpContainerWrapper" :class="responsiveClass=='flb-w200'?'responsive':''"> 
            <div class="d-flex align-center"> 
              <div class="questionmarkIcon">?</div>
              <button type="button" class="buttonTextOnly" @click="showFacebookLogoutHelperText=!showFacebookLogoutHelperText">
                <p v-html="translatedWebMessages['wsm_facebook_logout_trouble']=='wsm_facebook_logout_trouble'?'Having trouble logging out of facebook?':translatedWebMessages['wsm_facebook_logout_trouble']">
                  Having trouble logging out of facebook?
                </p>
              </button> 
            </div>

              <Transition name="slideDown">
                <div v-if="showFacebookLogoutHelperText" class="facebookLogoutHelpContainer" >
                  
                <div class="" v-html="translatedWebMessages['wsm_facebook_logout_helpText']=='wsm_facebook_logout_helpText'?fbHelpText:translatedWebMessages['wsm_facebook_logout_helpText']"></div>
                </div>
              </Transition>
    
          </div>
          
        </div>
        
      </Transition>
    

    </div>



  </div>

  </div>
</template>

<script>

import loadingBalls from './loadingBalls.vue'

export default {
  name: 'FacebookLoginButton',
  components:{
    loadingBalls,

  },
  data(){
    return {
      // DEBUG
      debug: {
        methods: false,
        style: false,
        facebookDebugScript: false,
      },
      debugWidth: 400,
      userLoginStatus: '',
      facebookLoginScriptLoaded: false,
      facebookLoginScriptError: false,
      showFacebookScriptError: false,
      // DATA
      facebookButtonSizeArray: [200,300,400],
      
      buttonWidth: 400,
      padding: 20,
      isFacebookButtonLoading: true,
      isUserConnectedToFacebook: false,
      isRunningFirstTime: true,
      showFacebookLogoutContainer: false,
      showFacebookLogoutHelperText: false,
      windowLocOri: '',
      basedir: '',
      locale: '',
      isPointShop: null,
      facebookAppId: '162832940944179',
      webmessages: ['wsm_facebook_login','wsm_facebook_logout','wsm_facebook_welcome_user','wsm_facebook_logout_helpText', 'wsm_facebook_are_you_not_user','wsm_facebook_logout_trouble', 'wsm_facebook_script_error_helpText','wsm_facebook_script_error','wsm_facebook_script_error_solutions'],
      translatedWebMessages: {},
      fbHelpText: '<p class="title">Logout of Facebook:</p><p>- Go to <a href="https://www.facebook.com" target="_blank">facebook.com</a> and log out from their site.</p><p>- Then come back here and click the logout button above</p>',
      fbScriptErrorHelpText: '<p class="title">Solution(s):</p><p>If you are using "Private browsing", disable it and try again</p>',
      fbScriptErrorText: 'It appears that the browser is preventing Facebook from loading. ',
      fbScriptErrorSolutions: 'Solutions',
      // FB API TEST
      fbAPI: {
        fbUsername: '',
        fbShortName: '',
        fbMessage: '',
        id: '',
        short_name: '',
        email: '',
      },
      // Mutation Observer
      width: null,
      height: null,
      observer: null,
    }
  },
  props: {

  },
  created(){
    this.windowLocOri = window.location.origin;
    this.basedir = basedir;
    this.isPointShop = isPointShop;
    this.locale = window.locale;
    this.appendFacebookScript();
  },
  mounted() {
    this.initObserver(this.$refs.refFacebookLoginButton);
    this.getWebMessage();
  },
  watch:{
    buttonWidth(newValue, oldValue){

      this.isFacebookButtonLoading = true;
      this.$nextTick(()=>{
        this.reparseFBXFBML();
      })
      
    }
  },
  computed: {
    styleDebugBorder:function(){
      return {
        border: this.debug.style?'1px solid red':'none'
      }
    },
    responsiveClass: function(){

            if(this.width >= 400){
                //("Container greater than 400px");
                // buttonWidth is for sizing the loadingContainer
                this.buttonWidth = 400;
                return 'flb-w400';
            }else if(this.width <= 399 && this.width>=300){
                //("Container is smaller than 400px");
                this.buttonWidth = 300;
                return 'flb-w300';
            }else if(this.width <= 299){
                //("The container is smaller than 299")
                this.buttonWidth = 200;
                return 'flb-w200'
            }else{
                //("The Container size is undefined or something else went wrong");
                this.buttonWidth = 400;
                return 'flb-w400'
            }

        },
        
      },
  methods: {

    getWebMessage(){
      this.translatedWebMessages = cws(this.webmessages);
    },
    reparseFBXFBML(){
      /// reparse the DOM to show login button - if the facebook button has been changed in any way ( Like size )
      if(this.facebookLoginScriptLoaded){

        return new Promise((resolve, reject)=>{

          FB.XFBML.parse(document.getElementById('facebookSpinnerWrapperId'),function (){
            resolve();
        });

        }).then(()=>{
          this.isFacebookButtonLoading = false;
        })
      }
    },
    appendFacebookScript(){
      return new Promise((resolve, reject)=>{

        /// Check is script already in the DOM
        if(document.getElementById('facebookLoginScriptv15') || document.getElementById('facebook-jssdkv15')){
          // Script is already in the html
          this.facebookLoginScriptLoaded = true;
          this.isFacebookButtonLoading = false; 
          this.onloadScript();
          return;
        }
        
        var script = document.createElement('script');
        let scriptURL = `https://connect.facebook.net/${this.locale}/sdk.js`;

        script.setAttribute('src', scriptURL);
        script.async = true;
        script.defer = true;
        script.id = "facebookLoginScriptv15"
        
        document.head.appendChild(script)
        
        // Attach a callback funtion on the script.
        script.onload = ()=>{
          
          this.facebookLoginScriptLoaded = true; 
          resolve();
          this.onloadScript();
        };
        script.onerror = (error) =>{
          reject(new Error('ERROR FACEBOOK SCRIPT'))
        }
        

      }).catch((error) => {
        // Handle error here.
        //console.error(error);
        this.facebookLoginScriptError = true;

      });



      },
      
    initFacebook: async function (){

          window.fbAsyncInit = function() {
          FB.init({
            appId            : this.facebookAppId,
            xfbml            : true,
            cookie           : true,
            status           : false,
            localStorage     : false, // Default is true
            version          : 'v16.0'
          });

    
          
          FB.Event.subscribe('xfbml.render', (response)=>{
                this.finished_rendering();
              });
        }.bind(this)

    },

    facebookResponseHandler: function(response){
        if(!this.isRunningFirstTime){
            if(response.status === 'connected'){
              // WE REDIRECT
              this.facebookLogin();
            }else if(response.status === 'unknown'){
              // USER DID NOT LOG IN   
            }
          
          }; 
    },

    onloadScript: function(){
    
      this.initFacebook().then(()=>{
          
        // event subsbribers
        FB.Event.subscribe('auth.authResponseChange', this.facebookResponseHandler);
        FB.Event.subscribe('auth.login',this.facebookResponseHandler);
        FB.Event.subscribe('auth.statusChange',this.facebookResponseHandler);
        /// end event subscribers
      
        this.getLoginStatus().then(()=>{
            this.isRunningFirstTime = false;
          });

        });
    },
    logoutFacebook: async function(){
      if(typeof FB !== 'undefined'){

        return new Promise((resolve, reject)=>{  
          // Logout method
            FB.logout(function(response) {
              resolve(response);
            });
            
        }).then((response)=>{
          if(response){
            this.statusChangeCallback(response);
          }else{
            this.statusChangeCallback({'status':''});
          }
          sessionStorage.clear(); 
        })
        
	    }
    },
    getLoginStatus: async function () {

      return new Promise((resolve, reject) => {
        FB.getLoginStatus(function(response){
          resolve(response)
        })

      }).then((response)=>{

        this.statusChangeCallback(response)

      })
    },

    statusChangeCallback: function (response){  // Called with the results from FB.getLoginStatus().
    
      this.isFacebookButtonLoading = false;
      if (response.status === 'connected') {   // Logged into your webpage and Facebook.
        this.userLoginStatus = response.status;
        this.isUserConnectedToFacebook = true;
      
        this.getFacebookUserInfoAPI(response.authResponse.userID);

      } else {  
        this.userLoginStatus = "Not Logged in" // Not logged into your webpage or we are unable to tell.
        this.fbAPI.fbUsername = '';
        this.isUserConnectedToFacebook = false;

      }
  },



  getFacebookUserInfoAPI: function(userID) {   

    return new Promise((resolve, reject)=>{
      FB.api(`/${userID}?fields=id,name,email,picture,short_name`, function(response) {

        if(!response.hasOwnProperty('error')){
          resolve(response);
        }else{
          console.log('FB API ERROR:')
          reject(response);
        }   

      })
    }).then((response)=>{
       
        this.fbAPI['email'] = response.email; 
        this.fbAPI['short_name'] = response.short_name; 
        this.fbAPI['id'] = response.id; 

      }).catch((error)=>{
        console.log('FB API ERROR: ', error)
      });

  },

  logoutAndOpenLoginPromptFacebook: function(){

    this.isFacebookButtonLoading = true;
    this.logoutFacebook().then(()=>{

      this.openFacebookLoginPrompt();
    });
  },

  openFacebookLoginPrompt: function(){
    FB.logout(function(response) {
   // Person is now logged out
    });

  setTimeout(() => {
    FB.login(function(response){

    if(response.status=== 'connected'){
      //console.log("openFacebookLoginPrompt: Connected");
      //console.log("openFacebookLoginPrompt: We redirect now");
    }else{
      //console.log("openFacebookLoginPrompt: Not connected")
      //console.log("openFacebookLoginPrompt: User either cancelled or something else happened")
    }
    }, {scope: 'public_profile,email'})
    }, 1000)
  },

  facebookLogin: function () {   

    // Set button as loading
    this.isFacebookButtonLoading = true;

    let redirectURI = `${this.windowLocOri}${this.basedir}/loginServlet?Mode=facebookLogin`;
    let isPointShopRedirect = `https://graph.facebook.com/oauth/authorize?client_id=${this.facebookAppId}&state={isPointShop=${isPointShop}}&scope=email&redirect_uri=${encodeURIComponent(redirectURI)}`
    let defaultRedirect = `https://graph.facebook.com/oauth/authorize?client_id=${this.facebookAppId}&state={}&scope=email&redirect_uri=${encodeURIComponent(redirectURI)}&state={isPointShop:${window.isPointShop == 'Y'?'Y':'N'}}`

    //let defaultRedirect = `https://www.facebook.com/v18.0/dialog/oauth?client_id=${this.facebookAppId}&redirect_uri=${encodeURIComponent(redirectURI)}&state={isPointShop:'${window.isPointShop}'}`

    FB.getLoginStatus(async(response)=>{
        const permission = await this.checkPermissions()

        // Chech permissions if email is declined - refire the permissions 
        if(permission.data.find(x => x.permission == 'email').status == 'declined'){
          this.reauthenticate();
        }else{

          switch (response.status) {
              case 'connected':
  
                if(isPointShop == 'Y') {
                    window.top.location = isPointShopRedirect;
                } else {
                    window.top.location = defaultRedirect;
                }
                if(JSON.parse(document.cookie.split(';').find(c => c.trim().startsWith('cconsent')).split('=')[1]).categories.statistics.wanted) {
                  gtag('event', 'login', {
                      method: 'Facebook'
                  });
                }
              break;
  
              case 'unkown':

                //this.isFacebookButtonLoading = false;
  
                break;
              default:
                  if(isPointShop == 'Y') {
                      window.top.location = isPointShopRedirect;
                  } else {
                      window.top.location = defaultRedirect;
                  }
                  if(JSON.parse(document.cookie.split(';').find(c => c.trim().startsWith('cconsent')).split('=')[1]).categories.statistics.wanted) {
                    gtag('event', 'login', {
                        method: 'Facebook'
                    });
                  }
          }

        }

        }, true, {scope: 'public_profile,email'});

     },
     finished_rendering: function(){
       this.$nextTick(()=>{
         
         /// Button is finished rendering- We can now show the button
         this.isFacebookButtonLoading = false;
       })
     },

    ////// DEBUGGING ////////
    async reauthenticate(){
      console.log('reauthenticate')
      await this.deletePermissions();

      FB.login(function(response){
        console.log(response)
      },{auth_type:'reauthenticate'})
    },
    dissociateUser(){
      FB.api(`${this.facebookAppId}/`)
    },
    async deletePermissions(){
      return new Promise((resolve,reject)=>{
        FB.api(`/${this.fbAPI.id}/permissions`, 'delete', function(response){
          console.log("Delete response",response)
          resolve(response)
        })

      })
    },


    checkPermissions(){
      return new Promise((resolve, reject)=>{
        FB.api('/me/permissions', function(response) {
          resolve(response);

        });
      
      })
    }, 

    ///// OBSERVER METHODS ///////
    onResize: function() {
        const box = this.$refs.refFacebookLoginButton,
          width = box.offsetWidth,
          height = box.offsetHeight

        this.width = width
        this.height = height
        
        this.$emit('resize', { width, height })
      },
        initObserver: function(element) {
        const observer = new ResizeObserver(this.onResize)
        observer.observe(element)
        this.observer = observer
      },
      destroyObserver: function(element){
        if (this.observer) this.observer.unobserve(element);
      } 
  },
  beforeDestroy() {
          this.destroyObserver(this.$refs.refFacebookLoginButton);
      },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$facebookColor: #1877f2;
p{
  margin-bottom: 0;
}
.facebookLoginButton{
  width: 100%;

  *{box-sizing: border-box;}
  span{
    line-height: 0;
  }
}
.fb-login-button{
  // This value prevents the button from expanding / prevents layout shifts
  max-height: 40px;
}
.fb-login-button span{
  line-height: 0;
}
.d-none{
  display: none;
}

.facebookButtonOuterWrapper{
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.facebookButtonUserInfo{
  border: 2px solid $facebookColor;
  border-radius: 5px;
  background: white;
  position: relative;
  top: -5px;
  z-index: 4;
  padding: 5px 10px;
  transition: all .2s ease;

}
.d-flex{
  display: flex;
  gap: 5px;
}
.flex-wrap{
  flex-wrap: wrap;
}
.just-center{
  justify-content: center;
}
.align-center{
  align-items: center;
}

#facebookLoginButtonId {
  .fbText{
    margin-bottom: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 12px;
  }
  .bold{
    font-weight: bold;
  }
  .fbCol{
    color: $facebookColor;
  }
  .facebookButtonUserInfoText{

  }
  .facebookChangeUserText{
    margin-bottom: 0;
    font-size: 0.8em;
    cursor: pointer;
    width: fit-content;
    &:hover{
      text-decoration: underline;
      
    }
  }
  .facebookErrorContainer{
    background: $facebookColor;
    padding: 2px;
    border-radius: 3px;
    font-size: 13px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    gap: 5px;
    min-height: 40px;
    .facebookLogo{
      width: 37px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      background: white;
      border-radius: 2px;
      svg{
        width: 25px;
        height: 25px;
        fill: $facebookColor;
      }
    }
    .errorTextWrapper{
      padding: 5px 10px;
      font-size: 100%;
      .errorText{
      color: white;
      font-size: 1em;
      width:100%;
      line-height: 1.2;
    }
  }
  }
}

.facebookHorizontalLine{
  background: $facebookColor;
  width: 100%;
  height: 1px;
  margin-top: 5px;
}
.facebookLogoutButton{
  border: none; 
  background: #e4e6eb;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  cursor: pointer;
  min-height: 25px;
  padding: 5px;
  margin: 10px 0px;
  border-radius: 3px;
  p{
    font-weight: bold;
    color: #000;
    font-size: 13px;
    
  }
}
.buttonTextOnly{
  border: none; 
  padding: 0;
  background: transparent;
  cursor: pointer;
  &:hover{
    text-decoration: underline;
  }
}
.questionmarkIcon{
  background: #333;
  border-radius: 100%;
  width: 15px;
  height:15px;
  min-width:15px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  margin-right: 5px;
  font-size: 11px;
}
  .facebookSpinnerWrapper{
 // transition: all .3s ease;
 position: relative;
 z-index: 5;
  border-radius: 5px;
  min-height: 40px;
  max-width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;

  &.loading{
  background: $facebookColor;
  color: white;
  text-align: center;
  }

}

.fadeSpinner-enter-active, .fadeSpinner-leave-active {
  transition: all .2s;
}
.fadeSpinner-enter, .fadeSpinner-leave-to {
  opacity: 0;
}
.slideDown-enter-active, .slideDown-leave-active {
  transition: all .2s;
}
.slideDown-enter, .slideDown-leave-to {
  opacity: 0;
  transform: translateY(-30px)

}
</style>
<style lang="scss">
#facebookLoginButtonId .facebookLogoutHelpContainerWrapper{
  align-self: flex-start;
  padding: 0px 10px;
}
#facebookLoginButtonId .facebookLogoutHelpContainerWrapper.responsive{
  padding: 0px 0px;
  margin-top: 30px;
  .questionmarkIcon{
    display:none;
  }
  .buttonTextOnly{
    padding: 7px 15px;
    border-radius: 3px;
    background: #e4e6eb;
  }
}
#facebookLoginButtonId .facebookButtonOuterWrapper{
  *{
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    //font-size: 13px;
    p,a{
      margin-bottom: 0;
      padding: 0;

    }
  }

}
.d-inline{
  display: inline;
}
#facebookLoginButtonId .facebookErrorContainer{
  text-align: left;
}
#facebookLoginButtonId .facebookLogoutHelpContainer, .facebookLoginScriptError{
  padding: 10px 0px;
  font-size: 13px;
  *{
    font-size: 1em;
  }
  p{
    font-size: 1em;
  }
  a{
    display: inline; 
    text-decoration: underline;
  }
  .title{
    font-weight: bold;
  }
  .fbHelpText{
 
}
}
</style>